var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLevelUpJp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3575 57.9959L22.1917 84.6075C17.6028 87.5768 17.6028 94.3028 22.1917 97.2496L63.38 123.771C70.1059 128.09 78.744 128.113 85.47 123.794L126.906 97.2721C131.517 94.3253 131.54 87.5768 126.906 84.6075L85.4925 57.9734C78.744 53.6319 70.061 53.6319 63.335 57.9959H63.3575Z",
    fill: "url(#paint0_linear_1269_23143)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.049 82.2005L85.8525 106.495C78.6991 111.061 70.331 111.084 63.2001 106.495L25.4311 82.133C25.4311 82.133 23.3166 83.5052 23.339 83.5502C23.5415 83.9776 24.0814 84.36 25.0037 84.9674L60.7931 108.475C64.9547 111.151 69.7461 112.501 74.515 112.501C79.284 112.501 84.0304 111.174 88.192 108.52L124.274 85.4173C125.376 84.7199 126.028 84.5175 126.186 83.5952C126.186 83.5502 124.049 82.2005 124.049 82.2005Z",
    fill: "url(#paint1_linear_1269_23143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3575 41.7096L22.1917 68.3211C17.6028 71.2904 17.6028 78.0164 22.1917 80.9633L63.38 107.485C70.1059 111.804 78.744 111.826 85.47 107.507L126.906 80.9858C131.517 78.0389 131.54 71.2904 126.906 68.3211L85.4925 41.6871C78.744 37.3456 70.061 37.3456 63.335 41.7096H63.3575Z",
    fill: "url(#paint2_linear_1269_23143)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.769 66.0041L86.3249 90.5236C79.1715 95.0901 70.8034 95.1126 63.6725 90.5236L25.1161 65.5092C25.1161 65.5092 23.0016 66.8814 23.0241 66.9264C23.2266 67.3538 23.7664 67.7362 24.6887 68.3436L61.243 92.5032C65.4046 95.1801 70.1735 96.5298 74.9649 96.5298C79.7563 96.5298 84.4803 95.2026 88.6418 92.5482L124.971 69.2209C126.073 68.5236 126.726 68.3211 126.883 67.3988C126.883 67.3538 124.746 66.0041 124.746 66.0041H124.769Z",
    fill: "url(#paint3_linear_1269_23143)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2347 25.8957L23.0689 52.5072C18.48 55.4765 18.48 62.2025 23.0689 65.1493L64.2572 91.6709C70.9831 95.9899 79.6212 96.0124 86.3472 91.6934L127.783 65.1718C132.394 62.225 132.417 55.4765 127.783 52.5072L86.3697 25.8732C79.6212 21.5316 70.9381 21.5316 64.2122 25.8957H64.2347Z",
    fill: "url(#paint4_linear_1269_23143)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4617 31.3844L33.4841 52.7096C29.8175 55.0941 29.8175 60.4704 33.4841 62.8323L66.4842 84.0676C71.883 87.5318 78.7889 87.5543 84.1877 84.0901L117.39 62.8323C121.079 60.4704 121.102 55.0716 117.39 52.6871L84.2102 31.3619C78.8114 27.8752 71.8605 27.8977 66.4617 31.3619V31.3844Z",
    fill: "url(#paint5_linear_1269_23143)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4412 77.0042L42.752 60.4029C39.8952 58.5583 39.8952 54.3518 42.752 52.5072L68.4637 35.9509C72.6703 33.2515 78.0466 33.2515 82.2531 35.9509L108.122 52.5072C111.002 54.3518 111.002 58.5583 108.122 60.4029L82.2756 77.0266C78.0691 79.726 72.6478 79.726 68.4412 77.0266V77.0042Z",
    fill: "url(#paint6_linear_1269_23143)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3431 68.5686L56.9014 59.2332C55.2817 58.1984 55.3042 55.8364 56.9014 54.8016L71.3431 45.5112C73.7051 43.9816 76.7419 43.9816 79.1039 45.5112L93.6356 54.8241C95.2552 55.8589 95.2552 58.2209 93.6356 59.2781L79.1039 68.6135C76.7419 70.1432 73.7051 70.1432 71.3206 68.6135V68.5686H71.3431Z",
    fill: "#FF8500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7481 65.9816L57.3064 56.6462C55.6868 55.6115 55.7093 53.2495 57.3064 52.2147L71.7481 42.9243C74.1101 41.3947 77.1469 41.3947 79.5089 42.9243L94.0406 52.2372C95.6603 53.272 95.6603 55.634 94.0406 56.6912L79.5089 66.0266C77.1469 67.5563 74.1101 67.5563 71.7257 66.0266V65.9816H71.7481Z",
    fill: "url(#paint7_linear_1269_23143)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5804 62.135L62.6826 55.7465C61.5804 55.0266 61.5804 53.407 62.6826 52.7096L72.5804 46.3436C74.2001 45.3088 76.2696 45.3088 77.8892 46.3436L87.8545 52.7096C88.9567 53.4295 88.9567 55.0491 87.8545 55.7465L77.9117 62.135C76.2921 63.1698 74.2001 63.1698 72.5804 62.135Z",
    fill: "url(#paint8_linear_1269_23143)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.455 96.7715L120.454 96.7712V96.7744L120.453 96.7766L120.447 96.7909C120.441 96.8034 120.432 96.8216 120.42 96.8451C120.397 96.892 120.362 96.9599 120.317 97.0465C120.228 97.2196 120.099 97.4671 119.94 97.7702C119.623 98.3765 119.187 99.2053 118.71 100.106C117.758 101.907 116.646 103.996 116.005 105.177L101.777 113.561C93.2108 110.369 84.8219 107.805 74.8598 107.827L74.8426 107.809L74.8479 107.804L74.8298 107.804C65.5839 107.827 55.4846 111.132 46.8934 114.326L32.3505 104.683L32.3503 104.683L32.3437 104.671L32.3177 104.624L32.2183 104.446C32.1322 104.291 32.008 104.067 31.856 103.791C31.552 103.239 31.1366 102.477 30.691 101.639C29.7996 99.9631 28.788 97.9847 28.3047 96.771C28.0374 95.9684 28.2654 95.0915 28.7836 94.3184C29.3018 93.5453 30.1088 92.8783 30.9943 92.4972C38.1566 89.4276 47.5801 87.5495 55.914 86.4389C64.2476 85.3283 71.4902 84.9853 74.29 84.9853L74.2906 84.9853C77.3823 84.8729 84.8495 85.2158 93.338 86.3546C101.826 87.4933 111.334 89.4276 118.508 92.4972C120.276 93.2581 120.992 95.1603 120.455 96.7715Z",
    fill: "url(#paint9_radial_1269_23143)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.455 96.7715L120.454 96.7712V96.7744L120.453 96.7766L120.447 96.7909C120.441 96.8034 120.432 96.8216 120.42 96.8451C120.397 96.892 120.362 96.9599 120.317 97.0465C120.228 97.2196 120.099 97.4671 119.94 97.7702C119.623 98.3765 119.187 99.2053 118.71 100.106C117.758 101.907 116.646 103.996 116.005 105.177L101.777 113.561C93.2108 110.369 84.8219 107.805 74.8598 107.827L74.8426 107.809L74.8479 107.804L74.8298 107.804C65.5839 107.827 55.4846 111.132 46.8934 114.326L32.3505 104.683L32.3503 104.683L32.3437 104.671L32.3177 104.624L32.2183 104.446C32.1322 104.291 32.008 104.067 31.856 103.791C31.552 103.239 31.1366 102.477 30.691 101.639C29.7996 99.9631 28.788 97.9847 28.3047 96.771C28.0374 95.9684 28.2654 95.0915 28.7836 94.3184C29.3018 93.5453 30.1088 92.8783 30.9943 92.4972C38.1566 89.4276 47.5801 87.5495 55.914 86.4389C64.2476 85.3283 71.4902 84.9853 74.29 84.9853L74.2906 84.9853C77.3823 84.8729 84.8495 85.2158 93.338 86.3546C101.826 87.4933 111.334 89.4276 118.508 92.4972C120.276 93.2581 120.992 95.1603 120.455 96.7715Z",
    stroke: "url(#paint10_linear_1269_23143)",
    strokeWidth: 0.0359919
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.501 105.123L115.321 104.425C115.321 104.425 120.112 95.6525 120.112 95.585C120.63 93.9653 119.932 92.0533 118.155 91.2884C103.803 85.1473 80.1161 83.5502 73.93 83.7751C68.3288 83.7751 44.9565 85.1473 30.6273 91.2884C28.8502 92.0533 28.1528 93.9653 28.6702 95.585C28.6702 95.6525 33.4616 104.425 33.4616 104.425L22.2816 105.123C20.5945 105.28 20.0546 107.372 21.4043 108.542L28.6477 114.751C29.48 115.47 29.66 116.685 29.0076 117.495L23.069 125.008C22.0117 126.336 23.2264 128.428 24.981 128.27L54.2919 119.632C54.2919 119.632 55.3267 119.092 54.7868 118.147L46.8911 108.407C55.4842 105.213 70.0609 105.1 74.2 105.1C78.4965 105.1 93.3207 105.213 101.891 108.407L93.9955 118.147C93.5906 118.732 93.9505 119.407 94.4904 119.587C94.4679 119.61 94.4454 119.632 94.4904 119.632L123.801 128.27C125.556 128.428 126.771 126.358 125.713 125.008L119.775 117.495C119.145 116.685 119.302 115.47 120.135 114.751L127.378 108.542C128.728 107.395 128.188 105.28 126.501 105.123Z",
    fill: "url(#paint11_linear_1269_23143)",
    stroke: "#E4032E",
    strokeWidth: 0.0719838,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.768 96.3443L118.762 96.3637C118.757 96.3672 118.752 96.3711 118.746 96.3752C118.732 96.3857 118.715 96.3981 118.696 96.4125C118.67 96.4314 118.639 96.4537 118.603 96.4792C118.479 96.569 118.296 96.6988 118.065 96.8629C117.601 97.191 116.94 97.6561 116.148 98.2123C114.563 99.3248 112.452 100.802 110.342 102.277C108.232 103.751 106.122 105.224 104.54 106.328L102.628 107.662L102.093 108.035L101.952 108.134L101.916 108.159L101.911 108.162C97.815 106.645 91.9126 105.813 86.5259 105.361C81.1349 104.908 76.2586 104.835 74.2225 104.835C72.2537 104.835 67.3774 104.936 61.9696 105.417C56.5662 105.898 50.6303 106.757 46.5341 108.274L46.5302 108.271L46.4954 108.246L46.36 108.145L45.846 107.765C45.4031 107.437 44.7704 106.968 44.0112 106.406C42.4928 105.281 40.4683 103.78 38.4437 102.277C36.4192 100.774 34.3947 99.2688 32.8763 98.1353C32.1171 97.5686 31.4845 97.0947 31.0416 96.7604C30.8202 96.5933 30.6463 96.4611 30.5277 96.3696C30.4684 96.3239 30.4231 96.2884 30.3926 96.2638C30.3773 96.2515 30.3659 96.2421 30.3584 96.2356C30.3549 96.2325 30.3525 96.2303 30.351 96.2288C30.0957 95.459 30.2683 94.3576 30.7168 93.3569C31.1658 92.3551 31.8887 91.46 32.7264 91.1025L32.7264 91.1025C39.5513 88.1792 48.5249 86.3911 56.4595 85.3339C64.3939 84.2767 71.2878 83.9506 73.9525 83.9506L73.9532 83.9506C76.8987 83.8381 84.0116 84.1642 92.0951 85.2495C100.179 86.3348 109.231 88.1791 116.056 91.1025C116.883 91.4601 117.684 92.3838 118.218 93.414C118.484 93.9288 118.683 94.4692 118.785 94.9773C118.886 95.4856 118.89 95.9602 118.768 96.3443Z",
    fill: "url(#paint12_linear_1269_23143)",
    stroke: "url(#paint13_linear_1269_23143)",
    strokeWidth: 0.0359919
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6051 118.983C54.5054 119.171 54.2893 119.309 54.0253 119.387L54.019 119.383L53.9766 119.352L53.8093 119.23L53.1702 118.763C52.6188 118.36 51.8298 117.783 50.8824 117.089C48.9875 115.703 46.4589 113.852 43.9297 112C41.4004 110.149 38.8704 108.296 36.9728 106.907L34.6796 105.228L34.0371 104.757L33.8678 104.633L33.8244 104.602L33.8134 104.594L33.813 104.593L28.9709 95.6231L46.4513 108.263L54.4801 118.248C54.6909 118.548 54.705 118.794 54.6051 118.983ZM54.0315 119.392C54.0317 119.392 54.0318 119.392 54.0316 119.392L54.0315 119.392Z",
    fill: "url(#paint14_linear_1269_23143)",
    stroke: "url(#paint15_linear_1269_23143)",
    strokeWidth: 0.0359919
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7185 119.36L94.7122 119.365C94.4482 119.286 94.2322 119.149 94.1324 118.96C94.0326 118.771 94.0466 118.526 94.2574 118.226L102.286 108.24L119.767 95.6007L114.924 104.571L114.924 104.571L114.913 104.579L114.87 104.611L114.7 104.735L114.058 105.205L111.765 106.884C109.867 108.274 107.337 110.126 104.808 111.978C102.279 113.829 99.75 115.68 97.8552 117.067C96.9077 117.76 96.1187 118.337 95.5673 118.741L94.9282 119.208L94.7609 119.33L94.7185 119.36ZM94.7059 119.369C94.7057 119.37 94.7059 119.369 94.706 119.369L94.7059 119.369Z",
    fill: "url(#paint16_linear_1269_23143)",
    stroke: "url(#paint17_linear_1269_23143)",
    strokeWidth: 0.0359919
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1381 102.283L47.3147 91.3242L52.0451 90.5372C52.8585 90.4018 53.5948 90.4315 54.2541 90.6261C54.9134 90.8207 55.4588 91.168 55.8903 91.6681C56.3218 92.1683 56.6022 92.8072 56.7316 93.5849C56.8622 94.3697 56.7975 95.0606 56.5375 95.6574C56.2811 96.2537 55.8618 96.7414 55.2797 97.1205C54.7011 97.4991 53.9944 97.7578 53.1596 97.8967L50.3342 98.3668L49.9496 96.0551L52.1757 95.6847C52.5253 95.6266 52.816 95.5342 53.0479 95.4076C53.2828 95.2769 53.4502 95.1042 53.5502 94.8896C53.6537 94.6744 53.6796 94.4116 53.628 94.1013C53.5757 93.7874 53.4655 93.5436 53.2973 93.3699C53.1321 93.1921 52.9169 93.0776 52.6517 93.0264C52.3896 92.971 52.0837 92.9724 51.7341 93.0306L50.6852 93.2051L52.1133 101.788L49.1381 102.283ZM54.7226 96.1849L58.2993 100.759L55.0672 101.297L51.5547 96.7119L54.7226 96.1849Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8813 102.643L46.9553 91.0673L51.994 90.2289C52.8448 90.0873 53.6299 90.116 54.3427 90.3264C55.0571 90.5372 55.6547 90.9166 56.1271 91.464C56.6027 92.0153 56.9031 92.7104 57.0401 93.5336C57.1783 94.3644 57.1132 95.1182 56.8245 95.7815C56.603 96.2964 56.2712 96.736 55.8346 97.0995L58.8696 100.981L54.9334 101.636L52.4074 98.3387L51.8712 98.4279L52.4731 102.045L48.8813 102.643ZM51.5117 98.171L52.5413 97.9996L55.0673 101.297L58.2994 100.759L55.394 97.0434C55.4806 96.9826 55.5632 96.9192 55.642 96.8532C56.0394 96.5205 56.338 96.1219 56.5377 95.6574C56.7977 95.0606 56.8624 94.3697 56.7318 93.5849C56.6024 92.8072 56.322 92.1683 55.8905 91.6682C55.459 91.168 54.9136 90.8207 54.2543 90.6261C53.595 90.4315 52.8586 90.4018 52.0453 90.5372L47.3149 91.3242L49.1383 102.283L52.1135 101.788L51.5117 98.171ZM52.1758 95.6848C52.5255 95.6266 52.8162 95.5342 53.0481 95.4076C53.283 95.2769 53.4504 95.1042 53.5504 94.8896C53.6539 94.6744 53.6798 94.4117 53.6282 94.1013C53.5759 93.7874 53.4657 93.5436 53.2975 93.3699C53.1323 93.1921 52.9171 93.0776 52.6519 93.0264C52.3897 92.971 52.0838 92.9724 51.7342 93.0306L50.6854 93.2051L51.127 95.8593L52.1758 95.6848ZM51.384 95.4997L52.1246 95.3765C52.4501 95.3223 52.7046 95.2389 52.8973 95.134C53.0821 95.0309 53.1987 94.9044 53.2671 94.7577C53.335 94.6164 53.3643 94.4194 53.3199 94.1526C53.2748 93.8817 53.185 93.703 53.073 93.5873L53.0685 93.5827C52.9535 93.4589 52.8004 93.3733 52.5927 93.3332C52.3787 93.288 52.1084 93.2851 51.7855 93.3389L51.045 93.4621L51.384 95.4997Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4082 100.073L61.1635 100.33L63.9415 88.9657L68.0514 88.6401L72.5847 99.4254L69.34 99.6826L66.2814 91.8494L66.1949 91.8563L64.4082 100.073ZM63.4562 95.7519L69.5562 95.2685L69.7344 97.5182L63.6345 98.0015L63.4562 95.7519Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6642 100.367L60.7573 100.676L63.6916 88.6721L68.252 88.3107L73.0402 99.7028L69.1334 100.012L68.3254 97.9433L65.1362 98.196L64.6642 100.367ZM64.4082 100.073L61.1635 100.33L63.9415 88.9657L68.0514 88.6401L72.5847 99.4254L69.34 99.6825L68.5321 97.6134L64.8801 97.9028L64.4082 100.073ZM65.381 95.5994L67.6747 95.4176L66.2814 91.8494L66.1949 91.8563L65.381 95.5994ZM65.7758 95.2546L67.2306 95.1393L66.3122 92.7875L65.7758 95.2546Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9166 88.7262L85.3203 99.82L82.8068 99.6849L79.1116 93.6409L79.0466 93.6374L78.7333 99.466L75.7216 99.3041L76.3179 88.2103L78.8746 88.3477L82.506 94.3666L82.5927 94.3713L82.9048 88.5644L85.9166 88.7262Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2453 88.431L85.6154 100.149L82.6258 99.9881L79.3096 94.5641L79.0285 99.7948L75.3926 99.5993L76.0225 87.8815L79.0566 88.0446L82.3282 93.4672L82.6094 88.2355L86.2453 88.431ZM82.5925 94.3712L82.5059 94.3666L78.8745 88.3477L76.3177 88.2103L75.7214 99.3041L78.7332 99.4659L79.0465 93.6374L79.1115 93.6409L82.8067 99.6849L85.3201 99.82L85.9164 88.7262L82.9047 88.5644L82.5925 94.3712Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3042 99.9131L89.7876 88.9028L92.7767 89.3055L92.177 93.7569L92.3275 93.7772L96.2389 89.7719L99.7227 90.2413L95.3418 94.6431L98.3253 101.263L94.7556 100.782L92.8388 96.3202L91.6758 97.4772L91.2934 100.316L88.3042 99.9131Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9527 100.181L89.5195 88.5513L93.1281 89.0375L92.5853 93.0658L96.125 89.4413L100.388 90.0156L95.7151 94.7109L98.8415 101.648L94.5383 101.068L92.7331 96.8661L91.9712 97.624L91.5612 100.667L87.9527 100.181ZM91.6757 97.4772L92.8387 96.3202L94.7555 100.782L98.3252 101.263L95.3417 94.6431L99.7226 90.2413L96.2389 89.7719L92.3274 93.7772L92.1769 93.7569L92.7766 89.3055L89.7875 88.9028L88.3041 99.9131L91.2933 100.316L91.6757 97.4772Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1269_23143",
    x1: 74.5824,
    y1: 127.033,
    x2: 74.5824,
    y2: 54.7117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1269_23143",
    x1: 23.339,
    y1: 97.3171,
    x2: 126.186,
    y2: 97.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFF3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1269_23143",
    x1: -0.775607,
    y1: 110.747,
    x2: -0.550658,
    y2: 38.4478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1269_23143",
    x1: 23.0241,
    y1: 81.0308,
    x2: 126.883,
    y2: 81.0308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFF3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1269_23143",
    x1: 75.4596,
    y1: 94.9101,
    x2: 75.4596,
    y2: 22.6114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1269_23143",
    x1: 75.4372,
    y1: 86.677,
    x2: 75.4372,
    y2: 28.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1269_23143",
    x1: 75.4372,
    y1: 33.9263,
    x2: 75.4372,
    y2: 79.0512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1269_23143",
    x1: 75.6848,
    y1: 57.2986,
    x2: 75.6173,
    y2: 31.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1269_23143",
    x1: 61.8503,
    y1: 54.2393,
    x2: 88.6643,
    y2: 54.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFF3B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1269_23143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.4249 99.6565) scale(34.3048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1269_23143",
    x1: 74.4109,
    y1: 84.9471,
    x2: 74.4109,
    y2: 114.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1269_23143",
    x1: 74.3912,
    y1: 83.7549,
    x2: 74.3912,
    y2: 128.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1269_23143",
    x1: 74.5464,
    y1: 83.9116,
    x2: 74.5464,
    y2: 108.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1269_23143",
    x1: 74.5464,
    y1: 83.9116,
    x2: 74.5464,
    y2: 108.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1269_23143",
    x1: 41.8004,
    y1: 95.5625,
    x2: 41.8004,
    y2: 119.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C10230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1269_23143",
    x1: 41.8004,
    y1: 95.5625,
    x2: 41.8004,
    y2: 119.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1269_23143",
    x1: 106.937,
    y1: 95.54,
    x2: 106.937,
    y2: 119.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C10230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1269_23143",
    x1: 106.937,
    y1: 95.54,
    x2: 106.937,
    y2: 119.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10230"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevelUpJp);
export default __webpack_public_path__ + "static/media/icon-level-up-jp.89743b69e88802ef4596fec3f96689a6.svg";
export { ForwardRef as ReactComponent };